import { DataProviderType } from 'apps/webcomponents/src/utils/request/request';
import { PendingTypes } from '../types';
import { ComputersAndVirtualMachinesView } from '../view/ComputersAndVirtualMachinesView';
import { Rights } from '@nirvana/shared/constants';

export class QuarantineActionEnabler {
  static handleActionButtons(view: ComputersAndVirtualMachinesView, selectedItems: Array<any>): void {
    let hasPendingInSelection = false;
    let hasEpsOrUnifiedInSelection = false;
    let hasScandinaviaInSelection = false;
    let hasVShieldInSelection = false;
    let hasVShieldUnSyncedInSelection = false;
    let hasGhostItems = false;

    for (const selection of selectedItems) {
      hasPendingInSelection = hasPendingInSelection || PendingTypes.includes(selection?.actionStatus);
      hasEpsOrUnifiedInSelection =
        hasEpsOrUnifiedInSelection ||
        selection?.recordSource == DataProviderType.EPS ||
        selection?.recordSource == DataProviderType.ENDPOINTS;
      hasScandinaviaInSelection =
        hasScandinaviaInSelection ||
        (!hasEpsOrUnifiedInSelection && !!selection?.source?.protectedEntity?.sve?.sveMultiPlatform);
      hasVShieldInSelection =
        hasVShieldInSelection ||
        (!hasEpsOrUnifiedInSelection && !selection?.source?.protectedEntity?.sve?.sveMultiPlatform);
      hasVShieldUnSyncedInSelection =
        hasVShieldUnSyncedInSelection || (hasVShieldInSelection && !!selection?.source?.protectedEntity?.sve?.unsynced);
      hasGhostItems = hasGhostItems || selection.isGhost;
    }

    const noSelection = selectedItems.length <= 0;

    const disableDeleteAction = hasVShieldUnSyncedInSelection || noSelection || hasPendingInSelection;

    const disableRestoreAction =
      hasVShieldInSelection || hasVShieldUnSyncedInSelection || noSelection || hasPendingInSelection || hasGhostItems;

    const disableDownloadAction =
      hasScandinaviaInSelection ||
      hasEpsOrUnifiedInSelection ||
      hasVShieldUnSyncedInSelection ||
      noSelection ||
      hasPendingInSelection;

    view.enableAddExclusions(!!selectedItems.length && Application.Main.hasAllRights([Rights.MANAGE_POLICIES_WRITE]));
    view.enableDelete(!disableDeleteAction);
    view.enableRestore(!disableRestoreAction);
    view.enableDownload(!disableDownloadAction);
  }

  /**
   * Check if user has all necessary rights to download quarantine archive
   */
  static userHasDownloadQuarantineRights(): boolean {
    return Application.Main.hasAllRights([Rights.RIGHT_MANAGE_INVENTORY, Rights.RIGHT_COMPANY_MANAGER]);
  }
}
